import { render, staticRenderFns } from "./SpaceDashboardMedia.vue?vue&type=template&id=0df0deb8&scoped=true&"
import script from "./SpaceDashboardMedia.vue?vue&type=script&lang=js&"
export * from "./SpaceDashboardMedia.vue?vue&type=script&lang=js&"
import style0 from "./SpaceDashboardMedia.vue?vue&type=style&index=0&id=0df0deb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0deb8",
  null
  
)

export default component.exports